import {
  StyledMaintenanceContentBox,
  StyledMaintenanceRowSpaceBox
} from './Styled';
import { Container } from '../../styles/chime-react/CommonStyles';
import Heading from '../chat/Heading';

const Maintenance = () => {
  return (
    <>
      <Container maxWidth="49rem" alignMiddle>
        <StyledMaintenanceContentBox>
          <Heading level={4} tag="h1" alignCenter={true}>
            現在メンテナンス中です
          </Heading>
          <StyledMaintenanceRowSpaceBox>
            <p>現在、メンテナンス作業を実施しております。</p>
            <p>
              ご不便をおかけして申し訳ありませんが、しばらくお待ちいただけますようお願いいたします。
              <br />
              ご利用の皆様には大変ご不便をおかけしておりますが、ご理解とご協力をいただきますようお願い申し上げます。
            </p>
          </StyledMaintenanceRowSpaceBox>
        </StyledMaintenanceContentBox>
      </Container>
    </>
  );
};

export default Maintenance;
